import { injectIntl } from 'react-intl';
import FormFooter from './FormFooter';

export default injectIntl(FormFooter);
